import { mapTeamPlayerToTeamParticipant } from 'modules/teams/domain/data-mappers/team-player.data-mapper';
import { EntryRequest } from 'modules/teams/domain/interfaces/entry-request';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import { TeamParticipant } from 'modules/teams/domain/interfaces/team-participant';

/**
 * Новые сверху. Порядок задавал слайс players при записи в стор; теперь он живёт
 * рядом с разбиением по вкладкам, чтобы источник данных на него не влиял.
 */
const byNewestFirst = (a: TeamPlayer, b: TeamPlayer) => b.id - a.id;

/** «Игроки» — записи состава, заведённые организатором вручную. */
export const selectSquad = (players: TeamPlayer[] = []): TeamPlayer[] => players.filter((player) => !player.isReal).sort(byNewestFirst);

/** «Участники» — реальные пользователи, вступившие в команду. */
export const selectParticipants = (players: TeamPlayer[] = []): TeamParticipant[] =>
  players
    .filter((player) => player.isReal)
    .sort(byNewestFirst)
    .map(mapTeamPlayerToTeamParticipant);

/** «Лист ожидания» — только заявки, по которым ещё нет решения. */
export const selectWaitingList = (entryRequests: EntryRequest[] = []): EntryRequest[] =>
  entryRequests.filter((entryRequest) => entryRequest.status === 'CREATED');
